import AdbButton from './src/adb-button.vue';

AdbButton.install = function (Vue) {
  Vue.component(AdbButton.name, AdbButton);
};

export default AdbButton;
